// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/common/v1/query_status.proto (package chalk.common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file chalk/common/v1/query_status.proto.
 */
export const file_chalk_common_v1_query_status: GenFile = /*@__PURE__*/
  fileDesc("CiJjaGFsay9jb21tb24vdjEvcXVlcnlfc3RhdHVzLnByb3RvEg9jaGFsay5jb21tb24udjEqowIKC1F1ZXJ5U3RhdHVzEhwKGFFVRVJZX1NUQVRVU19VTlNQRUNJRklFRBAAEiMKH1FVRVJZX1NUQVRVU19QRU5ESU5HX1NVQk1JU1NJT04QARIaChZRVUVSWV9TVEFUVVNfU1VCTUlUVEVEEAISGAoUUVVFUllfU1RBVFVTX1JVTk5JTkcQAxIWChJRVUVSWV9TVEFUVVNfRVJST1IQBBIYChRRVUVSWV9TVEFUVVNfRVhQSVJFRBAFEhoKFlFVRVJZX1NUQVRVU19DQU5DRUxMRUQQBhIbChdRVUVSWV9TVEFUVVNfU1VDQ0VTU0ZVTBAHEjAKLFFVRVJZX1NUQVRVU19TVUNDRVNTRlVMX1dJVEhfTk9ORkFUQUxfRVJST1JTEAhiBnByb3RvMw");

/**
 * @generated from enum chalk.common.v1.QueryStatus
 */
export enum QueryStatus {
  /**
   * Default value, should not be used
   *
   * @generated from enum value: QUERY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Pending submission to the database.
   *
   * @generated from enum value: QUERY_STATUS_PENDING_SUBMISSION = 1;
   */
  PENDING_SUBMISSION = 1,

  /**
   * Submitted to the database, but not yet running
   *
   * @generated from enum value: QUERY_STATUS_SUBMITTED = 2;
   */
  SUBMITTED = 2,

  /**
   * Running in the database.
   *
   * @generated from enum value: QUERY_STATUS_RUNNING = 3;
   */
  RUNNING = 3,

  /**
   * Error with either submitting or running the job.
   *
   * @generated from enum value: QUERY_STATUS_ERROR = 4;
   */
  ERROR = 4,

  /**
   * The job did not complete before an expiration deadline, so there are no results.
   *
   * @generated from enum value: QUERY_STATUS_EXPIRED = 5;
   */
  EXPIRED = 5,

  /**
   * Manually cancelled before it errored or finished successfully.
   *
   * @generated from enum value: QUERY_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,

  /**
   * Successfully ran the job.
   *
   * @generated from enum value: QUERY_STATUS_SUCCESSFUL = 7;
   */
  SUCCESSFUL = 7,

  /**
   * Succesfully ran the job, but encountered nonfatal errors (e.g. failed to run resolver on some rows)
   *
   * @generated from enum value: QUERY_STATUS_SUCCESSFUL_WITH_NONFATAL_ERRORS = 8;
   */
  SUCCESSFUL_WITH_NONFATAL_ERRORS = 8,
}

/**
 * Describes the enum chalk.common.v1.QueryStatus.
 */
export const QueryStatusSchema: GenEnum<QueryStatus> = /*@__PURE__*/
  enumDesc(file_chalk_common_v1_query_status, 0);

